<button [ngClass]="buttonClasses" [disabled]="disabled">
  <span class="text" [style.font-size]="fontSize">{{text}}</span>
  @if (icon) {
    <ion-icon [name]="icon"></ion-icon>
  }
</button>
